import { isNotDefined, isDefined, mapObject } from "../utils";

export function getValueFromOverride(override, index, key, defaultValue) {
  if (isDefined(override) && override.index === index) return override[key];
  return defaultValue;
}

// Merge a per-drawing appearance override (registry format) over the tool's
// base appearance. Deep-merges the stroke object; other keys shallow-override.
// Extracted verbatim from 8 tool files (dedup audit 2026-07-17, item 1e).
export function mergeAppearance(appearance, overrides) {
  if (!isDefined(overrides)) return appearance;
  const merged = { ...appearance };
  // Deep merge for stroke object
  if (overrides.stroke && typeof overrides.stroke === "object") {
    merged.stroke = {
      ...(appearance.stroke || {}),
      ...(overrides.stroke || {}),
    };
  } else if (overrides.stroke) {
    merged.stroke = overrides.stroke;
  }
  // Handle other properties
  Object.keys(overrides).forEach((key) => {
    if (key !== "stroke") {
      merged[key] = overrides[key];
    }
  });
  return merged;
}

// Resolve an appearance's stroke (object-or-string format) into the flat
// stroke/strokeWidth/strokeOpacity/strokeDasharray props the line components
// take. Extracted verbatim from the repeated ternary clusters in
// TrendLine/Ray/Segment/Line (dedup audit 2026-07-17, item 1e).
export function resolveStroke(appearance) {
  const strokeIsObject =
    appearance.stroke && typeof appearance.stroke === "object";
  return {
    stroke: strokeIsObject
      ? appearance.stroke.color || "#000000"
      : appearance.stroke || "#000000",
    strokeWidth: strokeIsObject
      ? appearance.stroke.width || 1
      : appearance.strokeWidth || 1,
    strokeOpacity: strokeIsObject
      ? appearance.stroke.opacity !== undefined
        ? appearance.stroke.opacity
        : 1
      : appearance.strokeOpacity !== undefined
        ? appearance.strokeOpacity
        : 1,
    strokeDasharray: strokeIsObject
      ? appearance.stroke.dash || "Solid"
      : appearance.strokeDasharray || "Solid",
  };
}

export function terminate() {
  this.setState({
    current: null,
    override: null,
  });
}

export function saveNodeType(type) {
  return (node) => {
    if (isNotDefined(node) && isDefined(this.nodes[type])) {
      delete this.nodes[type];
    } else {
      this.nodes[type] = node;
    }
    // console.error(this.nodes)
  };
}
export function isHoverForInteractiveType(interactiveType) {
  return function (moreProps) {
    // this has to be function as it is bound to this

    if (
      isDefined(this.nodes) &&
      Array.isArray(this.nodes) &&
      this.nodes.length > 0
    ) {
      const selecedNodes = this.nodes.map((node) =>
        node && node.isHover ? node.isHover(moreProps) : false,
      );
      const interactive = this.props[interactiveType].map((t, idx) => {
        return {
          ...t,
          selected: selecedNodes[idx] || false,
        };
      });
      return interactive;
    }
    return undefined;
  };
}

export function isHover(moreProps) {
  const hovering = mapObject(this.nodes, (node) =>
    node.isHover(moreProps),
  ).reduce((a, b) => {
    return a || b;
  });
  return hovering;
}

function getMouseXY(moreProps, [ox, oy]) {
  if (Array.isArray(moreProps.mouseXY)) {
    const {
      mouseXY: [x, y],
    } = moreProps;
    const mouseXY = [x - ox, y - oy];
    return mouseXY;
  }
  return moreProps.mouseXY;
}

export function getMorePropsForChart(moreProps, chartId) {
  // moreProps.chartConfig is already the configuration for the specific chart
  // where the event occurred, not a list of configurations
  const chartConfig = moreProps.chartConfig;

  // Handle case where chartConfig is not available
  if (!chartConfig) {
    console.warn(
      `Chart config not available in moreProps for chartId: ${chartId}`,
    );
    return {
      ...moreProps,
      chartConfig: null,
      mouseXY: moreProps.mouseXY || [0, 0],
    };
  }

  const origin = chartConfig.origin || [0, 0];
  const mouseXY = getMouseXY(moreProps, origin);
  return {
    ...moreProps,
    chartConfig,
    mouseXY,
  };
}

export function getSelected(interactives) {
  const selected = interactives
    .map((each) => {
      const objects = each.objects.filter((obj) => {
        return obj.selected;
      });
      return {
        ...each,
        objects,
      };
    })
    .filter((each) => each.objects.length > 0);
  return selected;
}
